/* istanbul ignore file */
import { UpdateForm } from 'framework/form';
import FinanceForm from 'domain/people/employee/finance/createupdate/FinanceForm';
import useFinanceService from 'domain/people/employee/finance/shared/financeService';
import { useFinanceId, useFinanceUrl } from 'domain/people/employee/finance/financeRouting';
import { SensitiveUpdatePageLayout } from 'framework/sensitiveData';

const UpdateFinance = () => {
  const { update, getById, getValidationSchema } = useFinanceService();
  const financeId = useFinanceId();
  const { getListUrl } = useFinanceUrl();
  const listUrl = getListUrl();

  return (
    <UpdateForm
      submitFormFunc={update}
      idSource="compensationId"
      getDataFunc={() => getById(financeId)}
      getValidationSchemaFunc={getValidationSchema}
      afterSubmit={{
        redirect: listUrl,
        message: 'You are awesome! The Compensation package has been successfully saved.',
      }}
    >
      <SensitiveUpdatePageLayout
        title="Edit: Compensation package"
        titleVariant="h4"
        timerId={listUrl}
        toggleSensitiveDataButtonProps={{ size: 'small' }}
      >
        <FinanceForm />
      </SensitiveUpdatePageLayout>
    </UpdateForm>
  );
};

export default UpdateFinance;
